import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const FINISHED = 'FINISHED'
export const TRANSFERRED = 'TRANSFERRED'
export const STORING_FINISHED = 'STORING_FINISHED'
export const CLIENT_RECEIVED = 'CLIENT_RECEIVED'

export const DEFAULT_COLORS = [
  '#1890FF',
  '#72B703',
  '#F29F05',
  '#A516D8',
  '#00C08F',
  '#F2695C',
  '#2E4BF2',
  '#9280FF',
  '#AB0E0E'
]
export let randomColors = null

const generateColors = () => {
  if (!randomColors) {
    randomColors = []
    for (let i = 0; i < 500; i++) {
      randomColors.push(`rgb(${[1, 2, 3].map((_) => (Math.random() * 256) | 0)})`)
    }
  }
}
generateColors()

export const getTasksStores = (tasks = []) => {
  const stores = []
  tasks.forEach(({ origin }) => {
    const exist = stores.find(({ name }) => name === origin.name)
    if (!exist) {
      const { name, latitude, longitude } = origin
      stores.push({ name, location: [latitude, longitude], hideTooltip: false })
    }
  })
  return stores
}

export const mapTaskToJobMap = (task = {}, onClickReference = () => {}) => {
  const {
    job_id,
    job_number: jobNumber,
    id,
    destination: { latitude, longitude },
    step_type
  } = task
  return {
    id,
    jobNumber,
    location: [latitude, longitude],
    partialStatus: step_type,
    onJobClick: () => onClickReference(job_id)
  }
}

export const mapResourceMap = (resource = {}) => {
  const {
    last_position: { latitude, longitude },
    last_update
  } = resource
  return {
    ...resource,
    latitude,
    longitude,
    lastUpdate: last_update
  }
}

export const getWeekFromTo = (day) => {
  const dateWithTz = day
  const starOfTheWeek = dateWithTz.startOf('week')
  const fromDate = starOfTheWeek.add(1, 'day').set('hour', 0).utc()
  const toDate = starOfTheWeek.add(7, 'day').set('hour', 23).set('minutes', 59).utc()
  return {
    from: fromDate.format(),
    to: toDate.format(),
    fromDate,
    toDate
  }
}

export const mapFleetsToColor = (fleets) => {
  return fleets.map((fleet, idx) => {
    return {
      ...fleet,
      label: fleet.name,
      value: fleet.id,
      color: DEFAULT_COLORS[idx] || randomColors[idx]
    }
  })
}

export const mapFleetQuotas = (fleetId, selectedQuotas = [], tz = 'America/Bogota') => {
  return selectedQuotas.map(({ props: { date, hour } }) => {
    // Freeze date to Client Timezone
    const dateWithTz = dayjs.tz(date, tz)
    return {
      from: dateWithTz.add(hour, 'hour').utc().format(),
      to: dateWithTz
        .add(hour + 1, 'hour')
        .utc()
        .format(),
      fleet_id: fleetId
    }
  })
}

export const mapQuotas = (selectedQuotas = [], tz = 'America/Bogota') => {
  return selectedQuotas.map(({ props: { date, hour } }) => {
    // Freeze date to Client Timezone
    const dateWithTz = dayjs.tz(date, tz)
    return {
      from: dateWithTz.add(hour, 'hour').utc().format(),
      to: dateWithTz
        .add(hour + 1, 'hour')
        .utc()
        .format()
    }
  })
}

export const getFleetsQuotas = (selectedQuotas = [], tz = 'America/Bogota') => {
  const quotasWithFleet = selectedQuotas.filter(({ props: { fleetQuota } }) => fleetQuota)
  const fleetIds = Array.from(
    new Set(
      quotasWithFleet.map(
        ({
          props: {
            fleetQuota: {
              fleet: { id }
            }
          }
        }) => id
      )
    )
  )
  const fleetQuotas = []
  for (const fleetId of fleetIds) {
    fleetQuotas.push({
      fleetId,
      quotas: mapQuotas(
        quotasWithFleet.filter(
          ({
            props: {
              fleetQuota: {
                fleet: { id }
              }
            }
          }) => id === fleetId
        ),
        tz
      )
    })
  }
  return fleetQuotas
}

export const getTasksStatus = (state) => {
  const status = {
    FINISHED,
    TRANSFERRED: FINISHED,
    STORING_FINISHED: FINISHED,
    CLIENT_RECEIVED: FINISHED,
    RE_ALLOCATED: 'RE_ALLOCATED',
    RESCHEDULED: 'RESCHEDULED',
    TASK_RESET: 'RESET',
    CANCELLED: 'CANCELED'
  }
  return status[state]
}

export const getStates = (states = []) => {
  let newStates = [...states]
  const finishedStateIdx = states.indexOf(FINISHED)
  if (finishedStateIdx >= 0) {
    newStates.splice(finishedStateIdx, 1, TRANSFERRED, STORING_FINISHED, CLIENT_RECEIVED)
  }
  return newStates
}

export const getFromTo = (from, to, tz) => {
  return {
    from: from.clone().tz(tz).set('hour', 0).utc().format(),
    to: to.clone().tz(tz).set('hour', 23).set('minutes', 59).utc().format()
  }
}
